import React, { useState } from 'react';
import Swal from 'sweetalert2';

const ViewProfile = () => {
  const [email, setEmail] = useState('');
  const [isEmailEmpty, setIsEmailEmpty] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsEmailEmpty(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setIsEmailEmpty(true);
    } else {
      // You can perform actions with the email here, like sending it to a server or displaying it.
      console.log('Email submitted:', email);
      // Display a success SweetAlert
      Swal.fire('Success', '', 'success');
    }
  };

  return (
    
    <div className="container-sm mt-4 col-lg-6"> {/* Use container-sm class for a smaller container */}
      <h2 className="card bg-primary rounded text-white mb-4">View Profile</h2>
      <form onSubmit={handleSubmit}>
        <div className={`mb-3 ${isEmailEmpty ? 'has-error' : ''}`}>
          <label htmlFor="emailInput" className="form-label">Email Address</label>
          <input
            type="email"
            className={`form-control ${isEmailEmpty ? 'is-invalid' : ''}`}
            id="emailInput"
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
          />
          {isEmailEmpty && <div className="invalid-feedback">Email is required.</div>}
        </div>
        <button type="submit" className="btn btn-primary">Submit</button>
      </form>
    </div>
  );
};

export default ViewProfile;
